// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"136":"7721f8e5339d895a","5218":"fa1d1106460f9604"}[chunkId] + ".js";
};